import { Box, SearchInput, SxProps } from '@modusign/design-system';
import { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { useDeferredState } from '@hooks';
import noop from '@libs/noop';

import { SearchParams } from '@app/features/externalDocument/components/DocumentListPage/SearchFilter';

import InstantSearchDropdown from '../InstantSearchDropdown';

interface SearchInputProps extends SxProps {
  initialInput?: string;
  documentRegisteredFilter: boolean;
  filter: SearchParams['filter'];
  onSubmit: (value: string) => void;
}

export default function ExternalDocumentSearchInput({
  initialInput,
  documentRegisteredFilter,
  filter,
  onSubmit,
  sx,
}: SearchInputProps) {
  const [value, setValue] = useDeferredState(initialInput || '');
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <OutsideClickHandler onOutsideClick={() => setShowDropdown(false)}>
      <Box
        height="36px"
        position="relative"
        sx={sx}
        onClick={() => setShowDropdown(true)}
        onFocus={() => setShowDropdown(true)}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit(value);
            setShowDropdown(false);
          }}
        >
          <SearchInput
            placeholder="계약 제목으로 찾기"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setShowDropdown(true);
            }}
            onClick={noop}
            onReset={() => {
              setValue('');
              onSubmit('');
            }}
          />
        </form>
        <InstantSearchDropdown
          documentRegisteredFilter={documentRegisteredFilter}
          filter={filter}
          isOpen={showDropdown}
          keyword={value}
          onSubmit={(keyword) => {
            onSubmit(keyword);
            setShowDropdown(false);
          }}
        />
      </Box>
    </OutsideClickHandler>
  );
}
